import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const KanbanLanesFilter = ({ onFiltered }) => {
  const [lanes, setLanes] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadLanes();
    }
    fetchData();
  }, []);

  const loadLanes = async () => {
    try {
      const { data } = await api.get('/tag/kanban/');
      setLanes(data.lista);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value.map(lane => lane.id));
  };

  return (
    <Box style={{ padding: "2px 10px" }}>
      <Autocomplete
        multiple
        size="small"
        options={lanes}
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        ListboxProps={{
          style: { 
            maxHeight: '200px', // Altura para mostrar mais opções
            overflow: 'auto', // Permitir scroll se houver mais opções
            padding: '8px 0', // Padding interno para melhor espaçamento
            borderRadius: '4px', // Bordas arredondadas
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)' // Sombra sutil
          }
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#eee",
                textShadow: "1px 1px 1px #000",
                color: "white",
                height: "20px",
                fontSize: "11px"
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Filtro por Lanes CRM"
            size="small"
            style={{ marginBottom: "4px" }}
          />
        )}
      />
    </Box>
  );
};

export default KanbanLanesFilter; 